import { authApi } from "@/api/authApi";
import { billingApi } from "@/api/billingApi";
import { IReservation } from "@/interfaces/Ipackages";
import { IPaymentMethodsResponse } from "@/interfaces/Ibilling";

interface UserStateInfo {
  identity_data_completion_needed: boolean;
  package_selection_needed: boolean;
  has_reserved: null | IReservation;
  has_payment_card: null | IPaymentMethodsResponse;
}

interface CheckStateResult {
  userStateInfo: UserStateInfo;
  shouldNavigate: boolean;
  navigateTo: string;
}

const checkState = async (): Promise<CheckStateResult> => {
  const userStateInfo: UserStateInfo = {
    identity_data_completion_needed: false,
    package_selection_needed: false,
    has_reserved: null,
    has_payment_card: null,
  };

  try {
    const userState = await authApi.getUserState();
    console.log("user state:", userState.data);

    if (userState.data.identity_data_completion_needed === true) {
      userStateInfo.identity_data_completion_needed = true;
    }

    if (userState.data.package_selection_needed === true) {
      userStateInfo.package_selection_needed = true;
      console.log(
        "Package selection is needed - user hasn't created reservation yet"
      );
    } else {
      // Only check for reservation if package_selection is NOT needed
      // This means backend says user has completed package selection
      try {
        const { packagesApi } = await import("@/api/packagesApi");
        const reservation = await packagesApi.getReservation();
        console.log("reservation:", reservation.data);
        if (reservation.data && reservation.data.reservation_id) {
          userStateInfo.has_reserved = reservation.data;
          userStateInfo.package_selection_needed = false;
        }
      } catch (error: any) {
        // Silently handle 404 - reservation might have expired
        if (error.response?.status === 404) {
          console.log("No reservation found");
        } else {
          console.error("Error fetching reservation:", error);
        }
      }
    }

    // Check for existing payment methods
    try {
      const paymentMethods = await billingApi.getPaymentMethods();
      console.log("payment methods:", paymentMethods.data);
      if (paymentMethods.data && paymentMethods.data.length > 0) {
        userStateInfo.has_payment_card = paymentMethods.data;
      }
    } catch (error) {
      console.log("No existing payment methods found");
    }
    console.log("user state info:", userStateInfo);

    // Check if user should navigate to dashboard
    // Navigate to dashboard if all required states are completed
    const shouldNavigate =
      userStateInfo.identity_data_completion_needed === false &&
      userStateInfo.package_selection_needed === false &&
      !userStateInfo.has_reserved &&
      userStateInfo.has_payment_card !== null;

    console.log(
      "shouldNavigate:",
      shouldNavigate,
      "navigateTo:",
      "/settings/myprofile"
    );

    // save user state info to local storage
    localStorage.setItem("userStateInfo", JSON.stringify(userStateInfo));

    return {
      userStateInfo,
      shouldNavigate,
      navigateTo: "/settings/myprofile",
    };
  } catch (error) {
    console.error("Error checking user state:", error);
    return {
      userStateInfo,
      shouldNavigate: true,
      navigateTo: "/settings/myprofile",
    };
  }
};

export { checkState, type UserStateInfo, type CheckStateResult };
